import type {AreaWithSensorInfo, MeetingRoom} from '@lib/store';

export function isMeetingRoom(entity: AreaWithSensorInfo | MeetingRoom): entity is MeetingRoom {
  if (entity.type === 'meetingRoom') {
    return true;
  }
  return false;
}
